import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspRedeemItemComponent } from './asp-redeem-item.component';

const routes: Routes = [
  {
      path: 'redeem',
      component: AspRedeemItemComponent,
  },
];

@NgModule({
  declarations: [AspRedeemItemComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ]
})
export class AspRedeemItemModule { }
